import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { BalancesListWrapper } from './balances-list/BalancesList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const balancesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Balance Management',
    path: '/admin/pages/balances',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/balances/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const BalancesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='balances'
          index
          element={
            <>
              <PageTitle breadcrumbs={balancesBreadcrumbs}>Balances list</PageTitle>
              <BalancesListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/balances/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/balances' />} />
    </Routes>
  )
}

export default BalancesPage
